import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IdentidadPersonaDto } from 'src/app/core/models/rnec/identidad-persona.dto';
import { ModalVariadoService } from 'src/app/core/services/modal-variado/modal-variado.service';
import { ObligatoriedadDocumentosService } from 'src/app/core/services/obligatoriedadDocumento/obligatoriedadDocumento.service';
import { DocumentosParentesco } from '../validadores/documentos-parentesco';
import { ObtenerDocumentosObligatoriosFactory } from '../validadores/obtenerDocumentosObligatoriosFactory';
import { ConsultaRnecService } from './consultaRnec.service';
import {SolicitudTiposEnum} from '../../../../../core/models/request/afiliaciones/solicitud-tipos.enum';


@Injectable({
  providedIn: 'root'
})
export class ParentescosService {
  private affiliationForm!: FormGroup;
  public botonContinuar: boolean = false;

  constructor(
    private consultaRnecService: ConsultaRnecService,
    private obligatoriedadDocumentosService: ObligatoriedadDocumentosService,
    private _ModalVariadoService: ModalVariadoService,
  ) {}

  public async obtenerDocumentosPorParentesco(
    personaControl: FormGroup,
    tipoPersona: string,
    form: any,
    index?: number
  ): Promise<{ botonContinuar: boolean, documentosTitular: any[] }> {
    this.inicializarValores(form);

    const parentesco = this.obtenerParentesco(tipoPersona, personaControl, form);

    try {
      await parentesco.obtenerDocumentos();
    } catch (error) {
      this._ModalVariadoService.modalError("servicio temporalmente no disponible");
      return { botonContinuar: false, documentosTitular: [] };
    }

    const datosPersona = this.obtenerDatosPersona(tipoPersona, personaControl.getRawValue(), index, form?.solicitudId);
    await this.consultaRnecService.realizarConsulta(
      tipoPersona,
      datosPersona?.identidadBeneficiario,
      personaControl,
      this.affiliationForm,
      index
    );


    const botonContinuar = this.consultaRnecService.botonContinuar;
    const documentosTitular = this.obligatoriedadDocumentosService.documentosTitular;

    this.consultaRnecService.botonContinuar = false;
    this.obligatoriedadDocumentosService.limpiarDocumentos();

    return { botonContinuar, documentosTitular };
  }


  private inicializarValores(form: any) {
    this.affiliationForm = form.trabajador;
    this.botonContinuar = false;

    this.obligatoriedadDocumentosService.limpiarDocumentos();
  }

  private obtenerParentesco(
    tipoPersona: string,
    personaControl: FormGroup,
    form: FormGroup
  ): DocumentosParentesco {
    return ObtenerDocumentosObligatoriosFactory.obtenerDocumentos(
      tipoPersona, personaControl, form, this.obligatoriedadDocumentosService
    );
  }

  private obtenerDatosPersona(tipoPersona: string, personaValue: any, index?: number, tipoSolicitud?: string) {
    const validacionesBeneficiario = new Map<number, boolean>();
    const estrategias = {
      trabajador: () => ({
        tipoIdentificacion: personaValue.TipoIdTrabajador,
        identidadBeneficiario: IdentidadPersonaDto.objTrabajadorARnc(personaValue),
        keyControl: 'trabajador.EsValido'
      }),
      conyuge: () => ({
        tipoIdentificacion: personaValue.TipoIdConyuge,
        identidadBeneficiario: tipoSolicitud === SolicitudTiposEnum.CEC
          ? IdentidadPersonaDto.objConyugeARnc(personaValue?.conyuge)
          : IdentidadPersonaDto.objConyugeARnc(personaValue),
        keyControl: 'conyuge.EsValido'
      }),
      beneficiario: () => {
        if (index !== undefined) {
          validacionesBeneficiario.set(index, false);
        }

        return {
          tipoIdentificacion: personaValue.tipoDocumento,
          identidadBeneficiario: IdentidadPersonaDto.objBeneficiarioARnc(personaValue),
          keyControl: `pacs[${index}].EsValido`
        };
      }
    };

    return estrategias[tipoPersona]?.() || {};
  }
}
